import type EventScope from 'owa-service/lib/contract/EventScope';
import type { EventScope as EventScopeType } from 'owa-graph-schema';

/**
 * Converts a GraphQL EventScope to EventScope.
 * @param scope The GraphQL EventScope object
 * @returns The converted EventScope instance
 */
export function mapGraphqlEventScopeToEventScope(scope: string): EventScope {
    switch (scope) {
        case 'ThisInstanceOnly':
            return 1;
        case 'ThisAndFollowingInstances':
            return 2;
        case 'AllInstancesInSeries':
            return 3;
        default:
            return 0;
    }
}

/**
 * Converts an EventScope to GraphQL EventScope.
 * @param scope The EventScope object
 * @returns The converted GraphQL EventScope instance
 */
export function mapEventScopeToGraphqlEventScope(scope: EventScope): EventScopeType {
    switch (scope) {
        case 1:
            return 'ThisInstanceOnly';
        case 2:
            return 'ThisAndFollowingInstances';
        case 3:
            return 'AllInstancesInSeries';
        default:
            return 'Default';
    }
}
